import { NodeModelTypeEnum } from '../enums';
import { Node } from '../Node';

export class AirFilterNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.AirFilter,
    });
  }
}
